<template>
  <v-layout row>
    <v-flex xs12>
      <div class="text-xs-center" v-if="!isJoined" style="margin-top: 10px;z-index: 10">
        <v-btn round large color="orange" dark
          :loading="isJoining" :disabled="isJoining" @click="joinChat">
          Join space<span slot="loader">Loading...</span>
        </v-btn>
      </div>

      <v-btn class="teal lighten-3" dark small absolute bottom right fab
        style="bottom: 70px;right: 20px; position: fixed; z-index: 1;"
        v-if="unreadFlag" @click="unreadFlag = false;scrollDown();" >
        <v-icon>arrow_downward</v-icon>
      </v-btn>

      <div class="au-chat__content" ref="scrollList">

        <infinite-loading direction="top" spinner="spiral"
          v-if="messages.length > 0" @infinite="infiniteHandler" style="margin-top: 20px">
          <div v-if="!user" slot="no-results">Sign-In is needed, if you want more loading :(</div>
          <div v-else slot="no-results">No messages :(</div>
        </infinite-loading>

        <div class="mess-wrap"
          :class="{ 'send-mess-wrap': message.me, 'recei-mess-wrap': !message.me }"
          v-for="(message, index) in messages" :key="'mess-' + index">
          <span class="mess-time">
            <span class="teal--text text--lighten-3">{{ message.user.name }}</span>
            <span v-if="message.createdAt">
              sent at {{ message.createdAt.toDate() | moment("MMMM Do YYYY, HH:mm") }}</span>
          </span>
          <div :class="{ 'send-mess__inner': message.me, 'recei-mess__inner': !message.me }">
            <v-avatar v-if="!message.me" size="40">
              <img :src="message.user.avatar" :alt="message.user.name">
            </v-avatar>
            <div :class="{ 'send-mess-list': message.me, 'recei-mess-list': !message.me }">
              <div :class="{ 'send-mess teal': message.me, 'recei-mess grey lighten-3': !message.me }"
                   v-if="message.type === 'text'" v-html="message.data"></div>
              <div v-if="message.type === 'emoji'">
                <emoji :emoji="message.data" :size="56" set="google"/></div>
              <template v-if="message.reactions">
                <v-tooltip v-for="(reaction, index2) in message.reactions"
                  :key="'emoji-' + index2" bottom>
                  <v-btn v-if="!user || (user && !isJoined)" slot="activator"
                    class="grey--text" flat icon
                    style="height: 20px;max-width: 20px;margin: 4px 8px">
                    <emoji :emoji="reaction.emoji" :size="20" set="google"/>
                      &nbsp;<span>{{ reaction.users.length }}</span>
                  </v-btn>
                  <v-btn v-else-if="user && reaction.users.indexOf(user.uid) >= 0"
                         flat icon slot="activator" class="teal--text"
                         style="height: 20px;max-width: 20px;margin: 4px 8px"
                         @click="removeEmoji(index2, message)">
                    <emoji :emoji="reaction.emoji" :size="20" set="google"/>
                      &nbsp;<span>{{ reaction.users.length }}</span>
                  </v-btn>
                  <v-btn v-else flat icon slot="activator" class="grey--text text--lighten-1"
                         style="height: 20px;max-width: 20px;margin: 4px 8px"
                         @click="addEmojiCount(index2, message)">
                    <emoji :emoji="reaction.emoji" :size="20" set="google"/>
                      &nbsp;<span>{{ reaction.users.length }}</span>
                  </v-btn>
                  <span>{{ reaction.emoji }}</span>
                </v-tooltip>
              </template>
            </div>
            <v-btn v-if="user" fab dark icon style="height: 20px;width: 20px;"
                   @click="clickEmojiPickerOnMessage(message)">
              <v-icon :size="14" class="grey--text">far fa-smile</v-icon>
            </v-btn>
          </div>
        </div>
      </div>

      <UserInput :onSubmit="onMessageWasSent" v-if="user && isJoined"/>

      <v-dialog v-model="picker" :max-width="338">
        <v-card>
          <Picker @select="addEmoji" set="google" :sheetSize="32"/>
        </v-card>
      </v-dialog>

    </v-flex>
  </v-layout>
</template>

<script>
import firebase from 'firebase';
import { Emoji, Picker } from 'emoji-mart-vue';
import InfiniteLoading from 'vue-infinite-loading';
import UserInput from '@/components/UserInput.vue';

export default {
  name: 'ChatScreen',
  components: {
    UserInput,
    Emoji,
    Picker,
    InfiniteLoading,
  },
  data() {
    return {
      chatRef: undefined,
      messages: [],
      picker: false,
      emojis: [],
      user: undefined,
      emojiAddMessage: null,
      limit: 10,
      messagePushFlag: false,
      scrollDownFlag: true,
      unreadFlag: false,
      isJoined: true,
      isJoining: false,
    };
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      this.user = user ? user : undefined;
      this.chatRef = firebase.firestore().doc(`communities/${this.$route.params.communityId}/chat/${this.$route.params.chatId}`);
      const messagesRef = this.chatRef.collection('messages').orderBy('createdAt', 'desc').limit(this.limit);
      if (user) {
        const chatUserRef = this.chatRef.collection('users').doc(this.user.uid);
        chatUserRef.get().then((userDoc) => {
          if (!userDoc.exists) {
            this.isJoined = false;
          }
        });

        this.messages = [];

        this.unsubscribe = messagesRef.onSnapshot((snapshot) => {
          if (snapshot.empty) {
            this.messagePushFlag = true;
          } else {
            let count = 0;
            snapshot.docChanges().forEach((change) => {
              if (change.type === 'added') {
                // console.log('added: ', change.doc.data())
                this.addedDoc(change.doc, this.messagePushFlag, () => {
                  count += 1;
                  if (count === this.limit || count === snapshot.size) {
                    this.messagePushFlag = true;
                  }
                });
              } else if (change.type === 'modified') {
                this.modifiedDoc(change.doc);
              }
            });
          }
        });
      } else {
        if (this.unsubscribe) this.unsubscribe();
        if (this.messages.length === 0) {
          const limitMessagesRef = this.chatRef.collection('messages').orderBy('createdAt', 'desc').limit(this.limit);

          limitMessagesRef.get().then((querySnapshot) => {
            if (!querySnapshot.empty) {
              querySnapshot.forEach((doc) => {
                this.addedDoc(doc);
              });
            }
          }).catch((error) => {
            console.error(error);
          });
        }
      }
    });
  },
  mounted() {
    this.scrollDown();
  },
  updated() {
    if (this.scrollDownFlag) this.scrollDown();
  },
  beforeDestroy() {
    if (this.unsubscribe) this.unsubscribe();
  },
  methods: {
    onMessageWasSent(message) {
      if (this.user.uid && message.data) {
        this.chatRef.collection('messages').add({
          user: {
            uid: this.user.uid,
            name: this.user.displayName,
            avatar: this.user.photoURL,
          },
          type: message.type,
          data: message.data,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        }).then(() => {});
      }
    },
    scrollDown() {
      this.$refs.scrollList.scrollTop = this.$refs.scrollList.scrollHeight;
    },
    addEmoji(emoji) {
      const currentReactions = this.emojiAddMessage.reactions ? this.emojiAddMessage.reactions : [];
      currentReactions.push({
        emoji: emoji.colons,
        users: [this.user.uid],
      });

      this.chatRef.collection('messages').doc(this.emojiAddMessage.id).update({ reactions: currentReactions });
      this.emojiAddMessage = null;
      this.picker = false;
    },
    removeEmoji(index, message) {
      if (message.reactions[index].users.length > 1) {
        message.reactions[index].users = message.reactions[index].users.filter(user => user !== this.user.uid);
      } else {
        message.reactions.splice(index, 1);
      }

      this.chatRef.collection('messages').doc(message.id).update({ reactions: message.reactions });
    },
    addEmojiCount(index, message) {
      message.reactions[index].users.push(this.user.uid);

      this.chatRef.collection('messages').doc(message.id).update({ reactions: message.reactions });
    },
    addedDoc(doc, pushFlag = false, callback = null) {
      const message = doc.data();
      const formattedMessage = {
        id: doc.id,
        user: {
          uid: message.user.uid,
          name: message.user.name,
          avatar: message.user.avatar,
        },
        type: message.type,
        data: message.data,
        createdAt: message.createdAt,
        reactions: message.reactions,
        me: this.user ? this.user.uid === message.user.uid : false,
      };

      if (pushFlag) {
        if (this.scrollDownFlag) {
          this.scrollDownFlag = true;
        } else {
          this.unreadFlag = true;
        }

        this.messages.push(formattedMessage);
      } else {
        this.messages.unshift(formattedMessage);
      }

      if (callback) callback();
    },
    modifiedDoc(doc) {
      const newMessage = doc.data();
      this.messages.forEach((oldMessage, index) => {
        if (oldMessage.id === doc.id) {
          this.messages.splice(index, 1, {
            id: doc.id,
            user: {
              uid: newMessage.user.uid,
              name: newMessage.user.name,
              avatar: newMessage.user.avatar,
            },
            type: newMessage.type,
            data: newMessage.data,
            createdAt: newMessage.createdAt,
            reactions: newMessage.reactions,
            me: this.user ? this.user.uid === newMessage.user.uid : false,
          });
        }
      });
    },
    infiniteHandler($state) {
      if (this.user && this.messages.length >= this.limit) {
        this.scrollDownFlag = false;

        const lastMessageCreateAt = this.messages[0].createdAt;
        const messagesRef = this.chatRef.collection('messages').orderBy('createdAt', 'desc').startAfter(lastMessageCreateAt).limit(this.limit);

        messagesRef.get().then((querySnapshot) => {
          if (querySnapshot.empty) {
            $state.complete();
          } else {
            querySnapshot.forEach((doc) => {
              this.addedDoc(doc);
            });
            $state.loaded();
          }
        }).catch(() => {
          $state.complete();
        });
      } else {
        $state.complete();
      }
    },
    clickEmojiPickerOnMessage(message) {
      this.emojiAddMessage = message;
      this.picker = true;
    },
    joinChat() {
      this.isJoining = true;
      const currentTimestamp = firebase.firestore.FieldValue.serverTimestamp();
      const batch = firebase.firestore().batch();
      const currentUserRef = firebase.firestore().doc(`users/${this.user.uid}`);

      batch.set(this.chatRef.collection('users').doc(this.user.uid), {
        userRef: currentUserRef,
        createdAt: currentTimestamp,
      });

      batch.set(currentUserRef.collection('myChat').doc(this.$route.params.chatId), {
        chatRef: this.chatRef,
        createdAt: currentTimestamp,
      });

      batch.commit().then(() => {
        this.isJoined = true;
        this.isJoining = false;
      }).catch((error) => {
        console.error("Failure: didn't join.\n", error);
      });
    },
  },
};
</script>

<style scoped>
  .au-chat__content {
    height: 80%;
    width: 100%;
    padding: 0 10px 0 20px;
    overflow-y: auto;
    position: fixed;
    font-size: 16px;
  }
  .mess-wrap {
    padding-top: 20px;
  }
  .recei-mess-wrap {
    text-align: center;
  }
  .send-mess-wrap {
    text-align: center;
    margin-top: 20px;
    padding-top: 0px !important;
  }
  .mess-time {
    font-size: 14px;
    color: #999;
  }
  .recei-mess__inner {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    margin-top: 6px;
  }
  .recei-mess__inner {
    -webkit-align-self: flex-end;
    -ms-flex-item-align: end;
    align-self: flex-end;
    justify-self: flex-start;
    margin-right: 10px;
  }
  .recei-mess-list {
    margin-left: 12px;
  }
  .recei-mess {
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
    padding: 8px 16px;
    max-width: 100%;
    margin-bottom: 2px;
    text-align: left;
    white-space:pre-wrap;
    white-space: -moz-pre-wrap;
    word-wrap:break-word;
    overflow-wrap: break-word;
  }
  .send-mess__inner {
    margin-top: 6px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    -moz-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
  }
  .send-mess {
    color: #fff;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
    padding: 8px 16px;
    max-width: 100%;
    min-width: auto;
    margin-bottom: 2px;
    text-align: left;
    white-space:pre-wrap;
    white-space: -moz-pre-wrap;
    word-wrap:break-word;
    overflow-wrap: break-word;
  }
</style>
